<template>
  <div>
    <div>
      <!-- {{$vuetify.breakpoint.name}} -->
      <v-row class="mt-0">
        <v-col cols="3" sm="3" md="3" lg="3" class="pt-0 pb-0 mt-0">
          <span class="ra-span-text">เครือ</span>
          <v-autocomplete
            v-model="nameTh"
            :items="nameThList"
            item-text="fullNameGroup"
            item-value="_id"
            clearable
            outlined
            dense
            class="mt-2"
            placeholder="ค้นหาจากชื่อเครือ"
            no-data-text="ไม่พบข้อมูล"
            @change="searchFilterData(), page=1"
          >
          <template v-slot:append>
            <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @change="searchFilterData(), page=1">
          </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="3" sm="3" md="3" lg="3" class="pt-0 pb-0">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            dense
          >
            <template v-slot:activator="{ on, attrs }">
              <span class="ra-span-text">วันที่สร้างเครือ</span>
              <v-text-field
                class="mt-2 "
                v-model="dateRangeTextCreate"
                placeholder="ปป/ดด/วววว - ปป/ดด/วววว"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              >
              <template v-slot:append>
                <v-icon color="#2BA197">mdi-calendar</v-icon>
              </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="datesCreateAt" range></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="3" sm="3" md="3" lg="3" class="pt-0 pb-0">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            dense
          >
            <template v-slot:activator="{ on, attrs }">
              <span class="ra-span-text">วันที่แก้ไขล่าสุด</span>
              <v-text-field
                v-model="dateRangeTextUpdate"
                placeholder="ปป/ดด/วววว - ปป/ดด/วววว"
                readonly
                v-bind="attrs"
                v-on="on"
                class="mt-2"
                outlined
                dense
              >
              <template v-slot:append>
                <v-icon color="#2BA197">mdi-calendar</v-icon>
              </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="datesUpdateAt" range></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="1" sm="1" md="1" lg="1" class="pt-0 pb-0 align-center justify-end mt-8">
          <v-btn
            class="button-color-outline mr-0 pl-4 pr-4"
            outlined
            elevation="0"
            @click="resetFilterData()"
          >ล้างข้อมูล</v-btn>
        </v-col>
        <v-col cols="2" sm="2" md="2" lg="2" class="pt-0 pb-0 d-flex align-center justify-end mt-4">
          <v-btn
            outlined
            class="button-color"
            dark
            @click="goPage()"
          >
          <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
          <span class="ra-text-in-button-groupcompany">
            เพิ่มบริษัทในเครือ
          </span>
        </v-btn>
        </v-col>
        <!-- <v-col cols="12" sm="12" md="6" lg="4" class="pt-0 pb-0 d-flex align-end">
          <v-row class="pl-3 pr-3" style="margin-bottom: 14px;">
            <v-btn class="mr-5" style="min-height: 38px;" color="success" dark @click="searchFilterData()">ค้นหา</v-btn>
            <v-btn class="" style="min-height: 38px;" outlined color="success" dark @click="resetFilterData()">ล้างข้อมูล</v-btn>
          </v-row>
        </v-col> -->
      </v-row>
    </div>
    <OverlayLoading :loading="loading" />
    <v-row>
      <v-spacer></v-spacer>
      <!-- <v-col class="d-flex align-center justify-end mb-3">
        <v-btn
          outlined
          class="ra-button"
          dark
          @click="openDialogCreate()"
        >
        <v-icon left dark color="#fff" size="14px">fa-plus</v-icon>
          <span class="ra-text-in-button">
            เพิ่มเครือบริษัท
          </span>
        </v-btn>
      </v-col> -->
    </v-row>
    <v-data-table
      :headers="headers"
      :items="groupCompanyList"
      :search="search"
      class="border-table-employee"
      :loading="loading"
      loading-text="Loading... Please wait"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100, -1],
        'items-per-page': 15
      }"
      :server-items-length="total || -1"
      @update:items-per-page="changePerPage"
      @update:page="changePage"
      disable-sort
    >
      <template v-slot:[`item.no`]="{ item }">
        {{ (perPage*(page-1)) + groupCompanyList.indexOf(item)+1 }}
      </template>
      <template v-slot:[`item.countCompany`]="{ item }">
        <span v-if="item.countCompany <= 0">{{ item.countCompany}}</span>
        <span v-else style="text-decoration: underline; color: #3776E9; cursor: pointer;" @click="openDialogManage(item)">{{ item.countCompany}}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              rounded
              dark
              small
              icon
              class="mt-3 mb-3"
              @click="goPageEdit(item)"
            >
            <!-- @click="openDialogEdit(item)" -->
            <template v-slot>
              <v-icon small color="#2BA197">mdi-pencil-outline</v-icon>
            </template>
            <!-- <v-icon dark color="#464646" small>fa-trash</v-icon> -->
            </v-btn>
          </template>
          <span class="label-table-action">แก้ไขข้อมูลเครือ</span>
        </v-tooltip>
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              rounded
              color="#FFB300"
              dark
              icon
              class="btn-manage-dep mt-3 mb-3 ml-2"
              @click="openDialogManage(item)"
            >
            <v-icon dark color="#464646" small>fa-plus-circle</v-icon>
            </v-btn>
          </template>
          <span class="label-table-action">จัดการบริษัทในเครือ</span>
        </v-tooltip> -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              rounded
              dark
              small
              icon
              class="mt-3 mb-3 ml-2"
              @click="checkDel(item._id)"
            >
            <template v-slot>
              <v-icon small color="error">mdi-delete-outline</v-icon>
            </template>
            <!-- <v-icon dark color="#464646" small>fa-pen</v-icon> -->
            </v-btn>
          </template>
          <span class="label-table-action">ลบบริษัท</span>
        </v-tooltip>
      </template>
    </v-data-table>

  <!-- Dialog Create Company -->
    <v-dialog v-model="dialogCreate" persistent max-width="600px">
        <template v-slot:activator="{}">
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Create Company</span>
          </v-card-title>
          <v-card-text>
            <v-container>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogCreate = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="dialogCreate = false">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirm = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="delGroupCompany()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <!-- Dialog Manage Company -->
      <DialogManageCompany/>
      <DialogEditGroupCompany/>
      <DialogCreateGroupCompany/>
  </div>
</template>
<script>
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import DialogManageCompany from './dialogManageCompany'
import DialogEditGroupCompany from './dialogEditGroupCompany'
import DialogCreateGroupCompany from './dialogCreateGroupCompany'
import moment from 'moment'
import OverlayLoading from '../../_template/OverlayLoading.vue'
export default {
  components: {
    // CreateGroupCompany
    OverlayLoading,
    DialogManageCompany,
    DialogEditGroupCompany,
    DialogCreateGroupCompany
  },
  data () {
    return {
      search: '',
      dialogConfirm: false,
      delConfirmId: '',
      dialog: false,
      dialogEdit: false,
      dialogCreate: false,
      dialogManageCompany: false,
      tokenUser: '',
      switch1: true,
      tab: null,
      date: new Date().toISOString().substr(0, 10),
      datesUpdateAt: [],
      datesCreateAt: [],
      menu: false,
      modal: false,
      menu2: false,
      textTitle: 'Create Company',
      nameThList: [],
      nameEngList: [],
      nameTh: '',
      nameEng: '',
      createAt: '',
      updateAt: '',
      inputs: [{
        name: '',
        party: ''
      }],
      items: [
        { tab: 'จัดการเครือ', content: 'Tab 1 Content' },
        { tab: 'จัดการบริษัท', content: 'Tab 2 Content' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'ชื่อเครือภาษาอังกฤษ', value: 'groupCompanyNameEng' },
        { text: 'ชื่อเครือภาษาไทย', value: 'groupCompanyNameTh' },
        { text: 'จำนวนบริษัท', value: 'countCompany' },
        { text: 'วันที่สร้าง', value: 'createAt' },
        { text: 'แก้ไขเมื่อ', value: 'updateAt' },
        { text: 'จัดการ', value: 'actions', sortable: false, align: 'center', width: '160' }
      ],
      groupCompanyList: [],
      editedIndex: -1,
      editedItem: {
        no: '1',
        groupCompanyNameTh: '',
        groupCompanyNameEng: '',
        createAt: '',
        updateAt: ''
      },
      defaultItem: {
        no: '2',
        groupCompanyNameTh: '',
        groupCompanyNameEng: '',
        createAt: '',
        updateAt: ''
      },
      loading: false,
      total: -1,
      perPage: 15,
      page: 1
    }
  },
  mounted () {
    EventBus.$on('closedialogcreate', this.getGroupCompanyLists)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.getGroupCompanyLists()
    this.getSelectGroupCompany()
  },
  computed: {
    dateRangeTextUpdate () {
      return this.datesUpdateAt.join(' ~ ')
    },
    dateRangeTextCreate () {
      return this.datesCreateAt.join(' ~ ')
    }
  },
  watch: {
    nameTh: function (val) {
    },
    nameEng: function (val) {
    },
    datesUpdateAt: function (val) {
      // this.createAt = ''
      // this.updateAt = ''
      // this.updateAt = this.datesUpdateAt[0] + ' ' + this.datesUpdateAt[1]
      if (this.datesUpdateAt[0] !== undefined && this.datesUpdateAt[1] !== undefined) {
        this.updateAt = this.datesUpdateAt[0] + ' ' + this.datesUpdateAt[1]
        this.searchFilterData()
      }
    },
    datesCreateAt: function (val) {
      // this.updateAt = ''
      // this.createAt = ''
      // console.log('Time datesCreateAt', this.datesCreateAt)
      // this.createAt = this.datesCreateAt[0] + ' ' + this.datesCreateAt[1]
      if (this.datesCreateAt[0] !== undefined && this.datesCreateAt[1] !== undefined) {
        this.createAt = this.datesCreateAt[0] + ' ' + this.datesCreateAt[1]
        this.searchFilterData()
      }
    }
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      this.getGroupCompanyLists()
    },
    changePage (value) {
      this.page = value
      this.getGroupCompanyLists()
    },
    async getGroupCompanyLists () {
      this.loading = true
      const temp = []
      const obj = {
        groupCompanyId: this.nameTh,
        createAt: this.createAt,
        updateAt: this.updateAt,
        page: this.page,
        limit: this.perPage
      }
      try {
        await this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/groupCompany/filter`,
          data: obj,
          headers: {
            authorization: this.tokenUser
          }
        }).then((response) => {
          response.data.result.map((el, index) => {
            el.createAt = this.initDate(el.createAt)
            el.updateAt = this.initDate(el.updateAt)
            temp.push({
              no: index + 1,
              companyFullName: el.companyFullNameTh + el.companyFullNameEng,
              ...el
            })
          })
          this.total = response?.data?.count || -1
          this.groupCompanyList = temp
          this.loading = false
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getSelectGroupCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/groupCompany/list`,
        headers: {
          authorization: this.tokenUser
        }
      }).then((response) => {
        // console.log('Get Edit List', response.data.result)
        this.nameThList = response.data.result.filter(el => {
          if (el !== '') { return el }
        })
        this.nameEngList = response.data.result.filter(el => {
          if (el !== '') { return el }
        })
      }).catch(e => {
        console.log(e)
      })
    },
    checkDel (id) {
      this.delConfirmId = ''
      this.delConfirmId = id
      this.dialogConfirm = true
      // var delId = id
      // swal('ต้องการลบข้อมูลนี้ ใช่หรือไม่!', {
      //   buttons: {
      //     cancel: 'ยกเลิก',
      //     catch: {
      //       text: 'ใช่',
      //       value: 'save'
      //     }
      //   }
      // })
      //   .then((value) => {
      //     switch (value) {
      //       case 'save':
      //         this.delGroupCompany(delId)
      //         break
      //       default:
      //         swal('คำเตือน', 'ข้อมูลยังไม่ถูกลบ', 'warning', {
      //           button: false,
      //           timer: 2000
      //         })
      //     }
      //   })
    },
    async delGroupCompany (id) {
      // console.log('ID Company', id)
      await this.axios({
        method: 'delete',
        url: `${this.api}/api/vMonk/groupCompany/` + this.delConfirmId,
        headers: {
          authorization: this.tokenUser
        }
      }).then((response) => {
        if (response.data.msg === 'Cannot Delete') {
          swal('ผิดพลาด', 'กรุณาลบบริษัทในเครือนี้ออกก่อน', 'error', {
            button: true
          })
        } else {
          swal('สำเร็จ', 'ลบข้อมูล สำเร็จ', 'success', {
            button: false,
            timer: 2000
          })
          this.getGroupCompanyLists()
          this.getSelectGroupCompany()
          this.dialogConfirm = false
        }
      }).catch(e => {
        console.log(e)
        swal('ผิดพลาด', 'ลบข้อมูล ไม่สำเร็จ!', 'error')
      })
    },
    searchFilterData () {
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.getGroupCompanyLists()
    },
    resetFilterData () {
      this.datesCreateAt = []
      this.datesUpdateAt = []
      this.nameTh = ''
      this.nameEng = ''
      this.createAt = ''
      this.updateAt = ''
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.getGroupCompanyLists()
    },
    goPage () {
      this.$router.push('/managecompany/createGroup')
      // this.$router.go('/')
    },
    goPageEdit (data) {
      this.$router.push('managecompany/editGroup/' + data._id)
    },
    openDialogManage (item) {
      this.dialogManageCompany = true
      EventBus.$emit('opendialogmanage', this.dialogManageCompany, item)
    },
    openDialogEdit (item) {
      // console.log('Item view', item)
      this.dialogEdit = true
      EventBus.$emit('opendialogedit', this.dialogEdit, item)
    },
    openDialogCreate (item) {
      // this.dialogEdit = true
      EventBus.$emit('opendialogcreate')
    },
    editCompany (value) {
      this.textTitle = ''
      this.dialogEdit = true
      this.textTitle = value
    },
    add () {
      this.inputs.push({
        name: '',
        party: ''
      })
      // console.log(this.inputs)
    },
    remove (index) {
      this.inputs.splice(index, 1)
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm น.')
    }
  }
}
</script>

<style scoped>
@import '../../../css/Re-Desing/Gobal-Design.css';
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.ra-btn-edit-dep-re {
  background-color: #F2F2F2 !important;
  color: #464646 !important;
}
.ra-border-button {
  background: #FFFFFF;
  /* Color / Neutral / #EEEEEE */
  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;

  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}
.btn-del-dep {
  background-color: #F2F2F2 !important;
  color: #464646 !important;
}
.btn-manage-dep {
  background-color: #F2F2F2 !important;
  color: #464646 !important;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #2BA197;
  border-radius: 4px;
}
.ra-text-in-button-groupcompany {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
</style>
